// Production alias target for '@localdemo' (see next.config.js). Mirrors
// index.js's export surface exactly — productionInert.test.js asserts this —
// so nothing that imports '@localdemo' needs a conditional import, but every
// export is inert: no seed data, no adapter, no fixture code reaches a
// production bundle through this file.
export const LOCAL_DEMO_SLUG = '__local_demo_disabled__';
export const LOCAL_DEMO_COMPANY_ID = -1;

export const isLocalDemoActive = () => false;
export const isLocalDemoArmed = () => false;
export const armLocalDemo = () => {};
export const disarmLocalDemo = () => {};
export const installLocalDemoTransport = () => {};
export const uninstallLocalDemoTransport = () => {};
export const resetStore = () => {};
export const startLocalDemoSession = () => {};
export const endLocalDemoSession = () => {};
export const DemoControlBar = () => null;
